import React from 'react';
import { Box, Typography } from '@mui/material';
import { Warning } from '@mui/icons-material';
import { generateClassName } from './helpers';
import CustomButton from './CustomButton';

const WarningWithAction = ({ message, actionLabel, onAction, className = null, bgColor = 'warning.main' }) => {
    return (
        <Box display="flex" alignItems="center" p={2} bgcolor={bgColor} color="warning.contrastText"
            className={generateClassName('warning-with-action', '', className)}
            borderRadius={2}
            sx={{ transform: 'scale(0.9)' }}
        >
            <Warning fontSize="large" />
            <Box ml={2} display={'flex'} flexDirection={'row'} alignItems={'center'} gap={2}>
                <Typography variant="body1">{message}</Typography>
                <CustomButton 
                    label={actionLabel}
                    onClick={onAction}
                    className='white_02'
                />
            </Box>
        </Box>
    );
};

export default WarningWithAction;